import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { hasAtLeast, isGlobalAdmin, profileConfirmed } from "../auth/roles";

export default function ProtectedRoute({ children, adminOnly = false, operatorOrAdmin = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#f5f5f5" }}>
        <div style={{ color: "#6b7280", fontFamily: "'DM Sans', sans-serif" }}>Loading…</div>
      </div>
    );
  }

  // With the page that was asked for, so the login can return to it. The
  // quotation mail links to a page behind the login (2026-09-24), and a
  // signatory who arrives signed out must land on the quotation, not on the
  // project list. LoginPage follows `next` only when it is a path on this site.
  if (!user) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }
  // **An account the facility has not confirmed lands on its profile**
  // (2026-09-28). The server refuses it every other route, so any other page
  // would be a screen of refusals; the profile is where it completes its
  // details and submits them. A self-registration's first sign-in lands on
  // /projects like everybody's and is brought here by this line.
  if (!profileConfirmed(user) && location.pathname !== "/profile") {
    return <Navigate to="/profile" replace />;
  }
  if (adminOnly && !isGlobalAdmin(user)) return <Navigate to="/projects" replace />;
  // "operator or above", so a group admin passes too. Named for what it gates
  // rather than for the two roles that used to be the whole list.
  if (operatorOrAdmin && !hasAtLeast(user, "operator")) return <Navigate to="/projects" replace />;
  return children;
}
